import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
/**
 * Servicio que controla. a traves de Observables, la visibilidad de ciertos elementos de la interfaz, tales como breadcrumb, nombre de usuario, panel de busquedas, buscador capas, etc.
 */
@Injectable({
  providedIn: 'root'
})
export class InterfazService {

  private breadcrumb$ = new BehaviorSubject<boolean>(false);
  private panelBusquedas$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.inicializar();
  }

  public inicializar() {
    this.mostrarBreadcrumb(false);
    this.mostrarPanelBusquedas(false);
  }

  public mostrarBreadcrumb(mostrar: boolean): void { this.breadcrumb$.next(mostrar); }
  public obtenerBreadcrumb(): Observable<boolean> { return this.breadcrumb$.asObservable(); }

  public mostrarPanelBusquedas(mostrar: boolean): void { this.panelBusquedas$.next(mostrar); }
  public obtenerPanelBusquedas(): Observable<boolean> { return this.panelBusquedas$.asObservable(); }






}
